import { render } from "./Select.vue?vue&type=template&id=41647524"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=41647524&lang=css"

import exportComponent from "/home/runner/work/vue-select/vue-select/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__